module.exports = __webpack_public_path__ + "files/f4f495489b281145ca7df80298e86342.png";